import styled from '@emotion/styled'

import type { ArcadeIcon } from '@arcade/web/icons/react'
import { DocumentIcon } from '@arcade/web/icons/react'
import { CardItemExternalAnchor } from '@cash-web/support/ui-components'

import type { SearchResult } from './types'

interface StyledListProps {
  fullScreenMode: boolean
}

const StyledList = styled.ul<StyledListProps>`
  list-style-type: none;
  padding: ${({ theme }) => theme.spacing.empty};
  margin: ${({ theme }) => theme.spacing.empty};

  li {
    background-color: ${({ theme }) => theme.colors.elevatedBackground};
  }

  > li a::after {
    position: absolute;
    width: ${({ fullScreenMode }) => (fullScreenMode ? '100%' : 'calc(100% - 55px)')};
    height: 1px;
    content: '';
    background-color: ${props => props.theme.colors.hairline};
    margin: auto;
    text-align: center;
    left: 0;
    right: 0;
  }

  > li a:hover::after {
    display: none;
  }

  > li:last-child a::after {
    display: none;
  }
`

const ResultCards = ({
  results,
  query,
  fullScreenMode,
}: {
  results: SearchResult[]
  query: string
  fullScreenMode: boolean
}) => {
  return (
    <StyledList fullScreenMode={fullScreenMode}>
      {results.map(result => (
        <li key={result.document_id}>
          <CardItemExternalAnchor
            icon={DocumentIcon as ArcadeIcon}
            title={result.title}
            subtitle={result.preview}
            to={`${result.url}?searchText=${encodeURIComponent(query)}`}
          />
        </li>
      ))}
    </StyledList>
  )
}

export default ResultCards
